import { useQuery } from '@tanstack/react-query';
import { createSubscriptionDoc } from 'shared/lib/@tanstack-query';
import { getLifeAreaById } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const queryKey = 'life-area-by-id';

export const useLifeAreaByIdQuery = (uid: ID = '', id: ID = '') =>
  useQuery({
    queryKey: [queryKey, uid, id],
    // The rules read `resource.data`, so a deleted life area answers permission-denied rather than an empty snapshot.
    queryFn: createSubscriptionDoc(() => getLifeAreaById(id), {
      expectedErrorCodes: ['permission-denied'],
    }),
    enabled: !!uid && !!id,
  });
